import React from "react";
import "./style.css";

class Nav extends React.Component {
  render() {
    return (
      <>
        <style>{`
          @keyframes borderSpin {
            0%   { --angle: 0deg; }
            100% { --angle: 360deg; }
          }
          @property --angle {
            syntax: '<angle>';
            initial-value: 0deg;
            inherits: false;
          }
          .resume-btn-wrap {
            position: relative;
            border-radius: 0.6rem;
            padding: 2px;
            background: conic-gradient(from var(--angle), #22c55e, #7c3aed, #22c55e);
            animation: borderSpin 3.5s linear infinite;
          }
          .resume-btn-wrap:hover {
            animation-duration: 1.4s;
          }
          .resume-btn {
            border-radius: 0.5rem;
          }
          .resume-icon {
            transition: transform 0.25s ease;
          }
          .resume-btn-wrap:hover .resume-icon {
            transform: translateY(2px);
          }
        `}</style>

        <header className="sticky top-0 z-10 bg-slate-900/90 backdrop-blur-md border-b border-slate-800">
          <div className="container mx-auto flex items-center justify-between px-6 sm:px-10 py-4">
            {/* Logo (uncomment if you want it back) */}
            {/* <a
              href="#about"
              className="title-font font-medium text-white text-xl mr-8 hidden md:block"
            >
              Rishi Gupta
            </a> */}

            {/* Nav links */}
            <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
              <a
                href="#projects"
                className="text-slate-400 hover:text-white transition-colors duration-200"
              >
                Past Work
              </a>
              <a
                href="#skills"
                className="text-slate-400 hover:text-white transition-colors duration-200"
              >
                Skills
              </a>
              <a
                href="#testimonials"
                className="text-slate-400 hover:text-white transition-colors duration-200"
              >
                Certifications
              </a>
            </nav>

            {/* Resume button with animated gradient border */}
            <div className="resume-btn-wrap">
              <a
                href="/doc/Resume Rishi Gupta.pdf"
                download="Rishi Gupta Resume"
                className="resume-btn inline-flex items-center gap-2 h-10 px-5 bg-slate-900 text-white text-sm font-semibold transition-colors duration-200 hover:bg-slate-800 focus:outline-none"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="resume-icon w-[18px] h-[18px]"
                  aria-hidden="true"
                >
                  <path d="M12 3v12" />
                  <path d="M7 10l5 5 5-5" />
                  <path d="M4 19.5h16" />
                </svg>
                Resume
              </a>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Nav;
